import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { mockBanks, mockUser } from "../../mocks/crypto";
import MobileBottomNav from "../../components/feature/MobileBottomNav";


export default function WithdrawNaira() {
  const navigate = useNavigate();
  const [step, setStep] = useState("form");
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [amount, setAmount] = useState("");
  const quickAmounts = [5000, 10000, 25000, 50000, 100000];
  const fee = amount ? Math.max(50, parseFloat(amount) * 0.005) : 0;

  const handleLookup = () => { if (accountNumber.length === 10) setAccountName("CHUKWUEMEKA OBI"); };
  const handleConfirm = () => { setStep("processing"); setTimeout(() => setStep("success"), 3000); };

  return (
    <div className="min-h-screen bg-[#F7F8FA] pb-28">
      <div className="bg-white px-5 pt-12 pb-4 flex items-center gap-3 border-b border-slate-100">
        <button onClick={() => step === "form" ? navigate("/home") : setStep("form")} className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center cursor-pointer hover:bg-slate-200">
          <i className="ri-arrow-left-line text-slate-600 text-lg"></i>
        </button>
        <h1 className="text-slate-800 font-bold text-lg" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Withdraw Naira</h1>
      </div>

      <div className="px-5 py-4">
        {step === "form" && (
          <div>
            <div className="bg-emerald-600 rounded-2xl px-4 py-4 mb-6 flex items-center justify-between">
              <div>
                <p className="text-emerald-200 text-xs font-medium">NGN Balance</p>
                <p className="text-white font-bold text-2xl" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>₦{mockUser.nairaBalance.toLocaleString()}</p>
              </div>
              <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
                <i className="ri-wallet-3-line text-white text-2xl"></i>
              </div>
            </div>

            <div className="space-y-4">
              <div>
                <label className="text-slate-600 text-xs font-medium mb-2 block">Amount (NGN)</label>
                <div className="relative">
                  <span className="absolute left-4 top-1/2 -translate-y-1/2 text-emerald-600 font-bold text-lg">₦</span>
                  <input type="number" value={amount} onChange={e => setAmount(e.target.value)} placeholder="0.00"
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl py-4 pl-9 pr-4 text-slate-800 text-sm placeholder-slate-300 focus:outline-none focus:border-emerald-500 focus:bg-white transition-colors" />
                </div>
                <div className="flex gap-2 mt-2 flex-wrap">
                  {quickAmounts.map(a => (
                    <button key={a} onClick={() => setAmount(String(a))} className="px-3 py-1 rounded-lg bg-white border border-slate-200 text-slate-500 text-xs whitespace-nowrap cursor-pointer hover:border-emerald-400 hover:text-emerald-600 hover:bg-emerald-50 transition-colors">₦{a.toLocaleString()}</button>
                  ))}
                </div>
              </div>
              <div>
                <label className="text-slate-600 text-xs font-medium mb-2 block">Select Bank</label>
                <select value={bankName} onChange={e => setBankName(e.target.value)} className="w-full bg-slate-50 border border-slate-200 rounded-xl py-4 px-4 text-slate-800 text-sm focus:outline-none focus:border-emerald-500 focus:bg-white transition-colors appearance-none">
                  <option value="">-- Select bank --</option>
                  {mockBanks.map(b => <option key={b.code} value={b.name}>{b.name}</option>)}
                </select>
              </div>
              <div>
                <label className="text-slate-600 text-xs font-medium mb-2 block">Account Number</label>
                <div className="flex gap-2">
                  <input type="text" value={accountNumber} onChange={e => { setAccountNumber(e.target.value); setAccountName(""); }} maxLength={10} placeholder="10-digit number"
                    className="flex-1 bg-slate-50 border border-slate-200 rounded-xl py-4 px-4 text-slate-800 text-sm placeholder-slate-300 focus:outline-none focus:border-emerald-500 focus:bg-white transition-colors" />
                  <button onClick={handleLookup} disabled={accountNumber.length !== 10} className="px-4 rounded-xl text-white text-sm font-semibold whitespace-nowrap disabled:opacity-40 cursor-pointer bg-emerald-600 hover:bg-emerald-700">Verify</button>
                </div>
                {accountName && <div className="flex items-center gap-2 mt-2"><i className="ri-check-line text-emerald-600 text-sm"></i><span className="text-emerald-600 text-xs font-semibold">{accountName}</span></div>}
              </div>
            </div>

            {amount && fee > 0 && (
              <div className="bg-slate-50 border border-slate-100 rounded-xl px-4 py-3 space-y-2 my-5">
                <div className="flex justify-between text-xs"><span className="text-slate-400">Transfer fee</span><span className="text-slate-600">₦{fee.toLocaleString()}</span></div>
                <div className="flex justify-between text-xs border-t border-slate-200 pt-2"><span className="text-slate-800 font-semibold">You Receive</span><span className="text-emerald-600 font-bold">₦{(parseFloat(amount) - fee).toLocaleString()}</span></div>
              </div>
            )}

            <button onClick={() => amount && bankName && accountName ? setStep("confirm") : undefined}
              disabled={!amount || !bankName || !accountName || parseFloat(amount) < 1000}
              className="w-full mt-6 py-4 rounded-2xl text-white font-semibold text-base whitespace-nowrap transition-all active:scale-95 disabled:opacity-40 bg-emerald-600 hover:bg-emerald-700">Continue</button>
            <p className="text-center text-slate-400 text-xs mt-2">Minimum withdrawal: ₦1,000</p>
          </div>
        )}

        {step === "confirm" && (
          <div>
            <h2 className="text-slate-800 text-xl font-bold mb-1" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Confirm Withdrawal</h2>
            <p className="text-slate-400 text-sm mb-6">Review your bank transfer details</p>
            <div className="bg-white border border-slate-200 rounded-2xl p-5 space-y-4 mb-6">
              <div className="flex justify-between"><span className="text-slate-400 text-sm">Amount</span><span className="text-slate-800 text-sm font-bold">₦{parseFloat(amount).toLocaleString()}</span></div>
              <div className="flex justify-between"><span className="text-slate-400 text-sm">Fee</span><span className="text-slate-600 text-sm">₦{fee.toLocaleString()}</span></div>
              <div className="flex justify-between border-t border-slate-100 pt-3"><span className="text-slate-800 text-sm font-bold">You Receive</span><span className="text-emerald-600 text-sm font-bold">₦{(parseFloat(amount) - fee).toLocaleString()}</span></div>
              <div className="flex justify-between"><span className="text-slate-400 text-sm">Bank</span><span className="text-slate-700 text-sm">{bankName}</span></div>
              <div className="flex justify-between"><span className="text-slate-400 text-sm">Account</span><span className="text-slate-700 text-sm">{accountNumber}</span></div>
              <div className="flex justify-between"><span className="text-slate-400 text-sm">Name</span><span className="text-emerald-600 text-sm font-semibold">{accountName}</span></div>
            </div>
            <button onClick={handleConfirm} className="w-full py-4 rounded-2xl text-white font-semibold text-base whitespace-nowrap transition-all active:scale-95 bg-emerald-600 hover:bg-emerald-700">Confirm &amp; Withdraw</button>
          </div>
        )}

        {step === "processing" && (
          <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
            <div className="w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center mb-6">
              <i className="ri-loader-4-line text-emerald-600 text-4xl animate-spin"></i>
            </div>
            <h2 className="text-slate-800 text-xl font-bold mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Processing Transfer</h2>
            <p className="text-slate-400 text-sm">Sending ₦{(parseFloat(amount) - fee).toLocaleString()} to {bankName}...</p>
          </div>
        )}

        {step === "success" && (
          <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
            <div className="w-20 h-20 rounded-full bg-emerald-100 border-2 border-emerald-200 flex items-center justify-center mb-6">
              <i className="ri-check-line text-emerald-600 text-4xl"></i>
            </div>
            <h2 className="text-slate-800 text-2xl font-bold mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Transfer Successful!</h2>
            <p className="text-slate-400 text-sm mb-4">Money sent to {accountName} · {bankName}</p>
            <div className="bg-emerald-50 border border-emerald-100 rounded-2xl px-6 py-4 mb-8 w-full max-w-xs">
              <p className="text-slate-400 text-xs mb-1">Amount Sent</p>
              <p className="text-emerald-600 text-3xl font-bold" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>₦{(parseFloat(amount) - fee).toLocaleString()}</p>
            </div>
            <button onClick={() => navigate("/home")} className="w-full max-w-xs py-4 rounded-2xl text-white font-semibold text-base whitespace-nowrap bg-emerald-600 hover:bg-emerald-700">Back to Home</button>
          </div>
        )}
      </div>
      <MobileBottomNav />
    </div>
  );
}
